export const situationControl: any = {
  A: 'ATIVO',
  C: 'CANCELADO',
  E: 'BLOQ. ADMINISTRATIVO',
  S: 'SUSPENSO',
  P: 'PENDENTE',
  M: 'BLOQ. FINANCEIRO',
  R: 'CORTESIA'
}
